"use client";

import { Text, type TextVariantProps } from "@/components/ui/Text";
import styles from "@/features/i18n/country-selector/index.module.css";
import { useLocale } from "@/i18n/client";
import { useSelection } from "@frend-digital/centra/client";
import { getLang } from "@frend-digital/next/i18n";
import { clsx } from "@frend-digital/ui";
import Image from "next/image";
import { Suspense, type ComponentProps } from "react";

const UnsuspendedCountryStatus = ({
	textVariant,
	imageSize,
	className,
}: {
	textVariant?: TextVariantProps;
	imageSize?: number;
	className?: string;
}) => {
	const locale = useLocale();

	const { data, isLoading } = useSelection({
		select: (data) => {
			return {
				countryCode: data.location?.country,
				currency: data.selection?.currency,
			};
		},
	});

	const size = imageSize ?? 15;

	if (isLoading || !data || !data.countryCode || !data.currency) return null;

	return (
		<div className={clsx(styles.countryStatus, className)}>
			<div style={{ width: size, height: size }} className={styles.statusImage}>
				<Image
					src={`https://flagcdn.com/w80/${data?.countryCode?.toLowerCase()}.png`}
					alt=""
					width={size}
					height={size}
				/>
			</div>
			<Text variant={textVariant ? textVariant : "utility5"}>
				{data?.countryCode} / {getLang(locale).toUpperCase()} ({data?.currency})
			</Text>
		</div>
	);
};

export const CountryStatus = (props: ComponentProps<typeof UnsuspendedCountryStatus>) => {
	return (
		<Suspense>
			<UnsuspendedCountryStatus {...props} />
		</Suspense>
	);
};
